import React, { PureComponent } from "react";
import { ICSSProps, ColorProps, GlobalColorPalette, ICSS, Color } from "@gago/frame";
import styled from "styled-components";
import { comdify } from "../../utils/common-function";

// tslint:disable:variable-name ter-max-len completed-docs jsx-no-multiline-js
const ResourceCardBody = styled.div<{colorPalette: GlobalColorPalette}>`
  height: 100%;
  width: 100%;
  background-color: rgba(0, 8, 15, 0.55);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 0 16px;
  .rc-title{
    margin-top: 12px;
    height: 12px;
    line-height: 1;
    color: #00cae0;
    font-size: 12px;
  }
  .rc-content{
    width: 100%;
    padding-top: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    .nun-box{
      font-size: 26px;
      line-height: 1px;
      font-family: BebasNeue;
      color: #c2fffa;
    }
    .num-suffix{
      margin-left: 3px;
      font-size: 14px;
      color: #c2fffa;
    }
  }
`;
type Rprops = {
  /** 标题 */
  title: string;
  /** 数量 */
  data: number;
  /** 单位 */
  suffix: string;
} & ICSSProps & ColorProps<GlobalColorPalette>;

/**
 * 资源概况，数据类型盒子
 * @author 马俊峰
 * @date 2020-07-30
 * @export
 * @class ResourceCard
 * @extends {PureComponent<Rprops>}
 * @implements {ICSS}
 * @implements {Color}
 */
export class ResourceCard extends PureComponent<Rprops> implements ICSS, Color {
  render() {
    const { colorPalette, style, className, title, data, suffix } = this.props;
    const showData = comdify(data);
    return(
      <ResourceCardBody colorPalette={colorPalette} style={style} className={className}>
        <div className="rc-title">{title}</div>
        <div className="rc-content">
          <span className="nun-box">{showData}</span>
          <span className="num-suffix">{suffix}</span>
        </div>
      </ResourceCardBody>
    );
  }
}
